const LIVEKIT_LOCAL_METADATA_TIMEOUT_MESSAGE = "Request to update local metadata timed out";
const SUPABASE_LOCK_STOLEN_MESSAGE =
  /^Lock "lock:[^"]+" was released because another request stole it$/;

const IGNORED_ERROR_MESSAGE_PATTERNS = [
  "AvatarView not initialized",
  "Called on script loaded before session recording is available",
];

const IGNORED_ERROR_MESSAGE_REGEXES = [/resizeobserver loop/i];

const LIVEKIT_SDK_ONLY_MESSAGES = [
  "Client initiated disconnect",
  "PC manager is closed",
  "Participant agent-",
];

function getErrorMessage(error: Error): string {
  return String(error?.message || "");
}

function getErrorName(error: Error): string {
  return String(error?.name || "");
}

function getErrorStack(error: Error): string {
  return String(error?.stack || "");
}

export function isExpectedLiveKitLocalMetadataTimeout(error: Error): boolean {
  if (getErrorMessage(error) !== LIVEKIT_LOCAL_METADATA_TIMEOUT_MESSAGE) {
    return false;
  }

  const errorName = getErrorName(error);
  const stack = getErrorStack(error);
  return errorName === "SignalRequestError" || stack.includes("node_modules/livekit-client");
}

export function isExpectedSupabaseLockStolenMessage(message: string): boolean {
  return SUPABASE_LOCK_STOLEN_MESSAGE.test(message);
}

export function isExpectedSupabaseLockStolenError(error: Error): boolean {
  const name = getErrorName(error);
  return (
    isExpectedSupabaseLockStolenMessage(getErrorMessage(error)) &&
    (name === "NavigatorLockAcquireTimeoutError" || name === "Error")
  );
}

function isSdkOnlyLiveKitError(error: Error): boolean {
  const message = getErrorMessage(error);
  const stack = getErrorStack(error);
  if (!stack.includes("node_modules/livekit-client")) return false;

  if (getErrorName(error) === "ConnectionError" && message === "Client initiated disconnect") {
    return true;
  }

  if (
    getErrorName(error) === "UnexpectedConnectionState" &&
    message.includes("PC manager is closed")
  ) {
    return true;
  }

  return LIVEKIT_SDK_ONLY_MESSAGES.some((pattern) => message.includes(pattern));
}

function isSdkOnlyAvatarKitRenderError(error: Error): boolean {
  const message = getErrorMessage(error);
  const stack = getErrorStack(error);
  return (
    message.includes("GPUDevice.createCommandEncoder: Unable to make command encoder") &&
    stack.includes("node_modules/@spatius/avatarkit")
  );
}

export function shouldSuppressKnownBrowserError(error: Error): boolean {
  if (isExpectedLiveKitLocalMetadataTimeout(error)) return true;
  if (isExpectedSupabaseLockStolenError(error)) return true;
  if (isSdkOnlyLiveKitError(error)) return true;
  if (isSdkOnlyAvatarKitRenderError(error)) return true;

  const message = getErrorMessage(error);
  if (IGNORED_ERROR_MESSAGE_PATTERNS.some((pattern) => message.includes(pattern))) {
    return true;
  }

  return IGNORED_ERROR_MESSAGE_REGEXES.some((pattern) => pattern.test(message));
}
